import { TYPE_REDUSER } from "../../utils/constants";

export const changeModalState = (payload) => ({
    type: TYPE_REDUSER.CHANGE_MODAL_STATE,
    payload
});